import React from "react"
import "./modal.scss"

const Modal = ({
  children,
  show,
  showHideModal,
  showHideModalOnClickOutSide,
}) => {
  if (!show) {
    return null
  }
  return (
    <div
      className="modal-backdrop"
      onClick={e => showHideModalOnClickOutSide(e)}
    >
      <div className="modal" id="modal">
        {children}
        <button className="toggle-button" onClick={showHideModal}>
          &#10005;
        </button>
      </div>
    </div>
  )
}

export default Modal
